/**
 * Facebook SSO Provider — stub, not yet implemented.
 *
 * When implementing:
 * - Load the Facebook SDK: https://connect.facebook.net/en_US/sdk.js
 * - Initialize with: FB.init({ appId: process.env.VUE_APP_FACEBOOK_APP_ID, version: 'v18.0' })
 * - Trigger login with: FB.login(callback, { scope: 'email,public_profile' })
 * - On success, authResponse.accessToken is the short-lived token to send to backend.
 * - Required env: VUE_APP_FACEBOOK_APP_ID
 */

export async function getToken() {
  throw new Error('Facebook sign-in coming soon!');
}
